<template>
    <div class="py-6 px-4 sm:p-6 lg:pb-8">
        
        <h2 class="text-lg leading-6 font-medium text-gray-900">Subjects & Levels</h2>
        <p class="mt-1 text-sm text-gray-500">
            Pick which subjects you teach.
        </p>

        <div ref="initialSearchSection" class="bg-gray-50 rounded-lg mt-3">
            <div class="px-4 py-5 sm:p-6">
                
                <form @submit.prevent="onAddLocation">
                    
                    <div class="grid grid-cols-12">
                        <div class="col-span-12 sm:col-span-6">
                            <label for="initialSearch" class="flex justify-between items-baseline block text-sm font-medium text-gray-700">
                                <span>Search <span class="hidden sm:inline">by</span> subject or level</span>
                                <button v-if="initialSearch || initialSearchResults.length > 0 || refineSearch || refineSearchResults.length > 0" @click="initialSearch = null; initialSearchResults = []; refineSearch = null; refineSearchResults = [];" class="underline text-xs">Clear<span class="hidden sm:inline"> search</span></button>
                            </label>
                            <div class="mt-1">
                                <!-- <v-select 
                                    ref="initialbox"
                                    v-model="initialSearch"
                                    :options="initialSearchResults"
                                    label="Description"
                                    @search="onInitialSearch"
                                    @input="onSelectInitialSearch"
                                    :noDrop="noDrop"
                                    :selectOnTab="true"
                                    :clearable="false"
                                    :filterBy="customFilterBy"
                                    placeholder="e.g. Maths, GCSE, 11+"
                                    class="vue-select block w-full border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400">
                                </v-select> -->
                                <!-- <multiselect
                                    v-model="initialSearch"
                                    :options="newInitialSearchResults"
                                    group-values="Levels"
                                    group-label="Description"
                                    track-by="Id"
                                    label="Description"
                                    @search-change="onInitialSearch"
                                    :internal-search="false"
                                    :clear-on-select="false"
                                    @select="onSelectInitialSearch"
                                    placeholder="e.g. Maths, GCSE, 11+"
                                    >
                                </multiselect> -->
                                
                                <div class="mt-1 rounded-md shadow-sm flex">
                                    <input
                                        id="initialSearch"
                                        :value="initialSearch"
                                        @input="initialSearch = $event.target.value"
                                        type="text"
                                        placeholder="e.g. Maths, GCSE, 11+"
                                        @focus="$refs.initialSearchSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })"
                                        class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 rounded sm:text-sm border-gray-300 placeholder-gray-400"
                                        />
                                </div>

                                <div v-if="initialSearch" class="w-full divide-y divide-gray-200">
                                    <div v-for="levelSet in newInitialSearchResults" :key="levelSet.Id" class="py-3">
                                        <h4 class="text-gray-400 font-medium">{{ levelSet.Description }}</h4>
                                        <div v-for="level in levelSet.Levels" class="flex justify-between items-center py-0.5" :key="level.Id">
                                            <div @click="level.Type === 'SUBJECT' ? onSelectSubject(level) : onSelectInitialSearch(level)" v-html="level.Description.replace(new RegExp(initialSearch, 'gi'), match => `<strong>${match}</strong>`)"></div>

                                            <tti-button v-if="level.Type === 'SUBJECT'" @click="onSelectSubject(level)" :disabled="subjects.some(x => x.id === level.Id)" size="xsmall">
                                                {{ subjects.some(x => x.id === level.Id) ? 'Selected' : 'Select' }}
                                            </tti-button>
                                            <tti-button v-else-if="level.Type === 'LEVEL'" @click="onSelectInitialSearch(level)" size="xsmall">
                                                Select
                                            </tti-button>
                                        </div>
                                    </div>
                                    <p v-if="initialSearch && newInitialSearchResults.length === 0" class="mt-5 text-center text-gray-600">No matches found.</p>
                                </div>

                                <!-- <multiselect
                                    v-if="initialSearch !== null && initialSearch.Type === 'LEVEL'"
                                    v-model="refineSearch"
                                    track-by="Id"
                                    label="Description"
                                    @search-change="onRefineSearch"
                                    :internal-search="false"
                                    :clear-on-search="false"

                                    placeholder="Refine by subject…"

                                    >
                                </multiselect>-->
                            </div>
                            <!-- <input v-model.trim="newLocationPostcode" type="text" name="postcode" id="postcode" autocomplete="postal-code" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm uppercase placeholder-gray-400 placeholder-normal-case" placeholder="e.g. DN55 1PT"> -->
                            <!-- <input v-model.trim="initialSearch" type="text" name="postcode" id="postcode" autocomplete="postal-code" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="e.g. Maths, GCSE, 11+"> -->
                        </div>
                    </div>

                    <div v-if="refineSearch || refineSearchResults.length > 0" ref="refineSearchSection" class="grid grid-cols-12 mt-6">
                        <div class="col-span-12 sm:col-span-6">
                            <div>
                                <label for="refineSearch" class="block text-sm font-medium text-gray-700">
                                    What subjects can you teach at {{ selectedInitialSearch.Description }} level?
                                </label>
                                <div class="mt-1 rounded-md shadow-sm flex">
                                    <input
                                        id="refineSearch"
                                        v-model="refineSearch"
                                        type="text"
                                        placeholder="Filter subjects…"
                                        class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 rounded sm:text-sm border-gray-300 placeholder-gray-400"
                                        />
                                </div>
                                <p v-if="refineSearchResults.length === 0" class="mt-5 text-center text-gray-600">No matches found.</p>
                            </div>

                            <div class="mt-1">

                                <table class="w-full" cellpadding="0">
                                    <template v-for="result in refineSearchResults">
                                        <tr>
                                            <td class="align-middle font-medium">{{ result.Description }}</td>
                                            <!-- <td class="py-1 text-right"><tti-toggle class="align-top"></tti-toggle></td> -->
                                            <td class="py-1 text-right">
                                                <tti-button @click="onSelectSubject(result)" size="xsmall" :disabled="subjects.some(x => x.id === result.Id)">
                                                    {{ subjects.some(x => x.id === result.Id) ? 'Selected' : 'Select' }}
                                                </tti-button>
                                            </td>
                                        </tr>

                                        
                                        <!-- <tr v-if="result.Levels !== undefined && result.Levels.length > 0"  v-for="level in result.Levels">
                                            <td class="pl-3">{{ level.Description }}</td>
                                            <-- <td class="py-1 text-right"><tti-toggle size="small" class="align-top"></tti-toggle></td> ->
                                            <td class="py-1 text-right"><tti-button>Select</tti-button></td>
                                        </tr> -->
                                    </template>
                                    <tr v-if="refineSearchResultsTotal > refineSearchResults.length">
                                        <td>+ {{ refineSearchResultsTotal - refineSearchResults.length  }} more</td>
                                    </tr>
                                </table>

                                <!-- <ul>
                                    <li v-for="result in refineSearchResults">
                                        <div class="flex justify-between">
                                            {{ result.Description }} <tti-toggle></tti-toggle>
                                        </div>
                                        
                                        <ul v-if="result.Levels !== undefined && result.Levels.length > 0">
                                            <li v-for="level in result.Levels" class="ml-3">
                                                {{ level.Description }} <tti-toggle></tti-toggle>
                                            </li>
                                        </ul>
                                    </li>
                                </ul> -->

                            </div>
                        </div>
                    </div>
                    
                    <!-- <ul class="mt-2">
                        <li v-for="result in initialSearchResults" @click="onSelectInitialSearch(result)" class="flex items-center space-x-1 text-gray-800">
                            <span v-html="result.Description.replace(new RegExp(initialSearch, 'gi'), match => `<strong>${match}</strong>`)" class="leading-7"></span>
                            <heroicon icon="caret-right" type="solid" class="w-5 h-5 text-gray-500 mt-0.5"></heroicon>
                        </li>
                    </ul> -->

                </form>

                <button type="button" @click="suggestionBoxOpen = true" class="mt-3 text-sm text-gray-500 underline">Can’t find the subject or level you teach?</button>
                <form v-if="suggestionBoxOpen" @submit.prevent="submitSuggestion" class="mt-3">
                    <h3 class="font-medium">Make a suggestion</h3>
                    <p class="text-sm">We’re adding new subjects and levels all the time, so if you don’t see something listed then provide some details and we’ll add it to our system.</p>

                    <div class="grid grid-cols-12">
                        <div class="col-span-12 sm:col-span-6">
                            <!-- <label for="suggestionSubject" class="mt-4 block text-sm font-medium text-gray-700">Subject</label>
                            <div class="mt-1 rounded-md shadow-sm flex">
                                <input v-model="suggestionSubject" name="suggestionSubject" id="suggestionSubject" class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm border-gray-300 placeholder-gray-400" placeholder="e.g. English" />
                            </div> -->

                            <!-- <label for="suggestionLevels" class="mt-4 block text-sm font-medium text-gray-700">Details</label> -->
                            <div class="rounded-md shadow-sm flex">
                                <textarea v-model="suggestionLevels" id="suggestionLevels" name="suggestionLevels" rows="2" class="shadow-sm focus:ring-light-blue-500 focus:border-light-blue-500 mt-2 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-400" placeholder="e.g. English - GCSE & A-Level"></textarea>
                            </div>
                            <!-- <p class="mt-2 text-sm text-gray-500">Give details of the subjects and/or levels you expect to teach.</p> -->

                            <!-- <label for="suggestionName" class="mt-4 block text-sm font-medium text-gray-700">Where can we contact you?</label>
                            <div class="mt-1 rounded-md shadow-sm flex">
                                <input v-model="suggestionName" name="suggestionName" id="suggestionName" class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm border-gray-300 placeholder-gray-400" />
                            </div>
                            <div class="mt-1 rounded-md shadow-sm flex">
                                <input v-model="suggestionEmail" name="suggestionEmail" id="suggestionEmail" class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm border-gray-300 placeholder-gray-400" />
                            </div> -->
                        </div>
                    </div>

                    <div class="mt-2 flex space-x-2">
                        <tti-button type="submit" size="small" :loading="submittingSuggestion" :disabled="submittingSuggestion">Submit</tti-button>
                        <tti-button @click="suggestionBoxOpen = false; resetSuggestionForm()" size="small" theme="outline" :disabled="submittingSuggestion">Cancel</tti-button>
                    </div>
                </form>

            </div>
        </div>

        <!-- <label class="block mt-6">Subject or Level</label>
        <input v-model="initialSearch" class="block" placeholder="eg. Maths, Piano, GCSE" /> -->

        <!-- <ul>
            <li v-for="result in initialSearchResults" @click="onSelectInitialSearch(result)" v-html="result.Description"></li>
        </ul> -->

        <!-- <div v-if="refineSearchResults.length > 0">
            <-- <label class="block mt-6">Refine</label>
            <input v-model="refineSearch" class="block" placeholder="eg. Maths, Piano, GCSE" /> ->

            <ul>
                <li v-for="result in refineSearchResults">
                    {{ result.Description }} <tti-toggle></tti-toggle>
                    
                    <ul v-if="result.Levels !== undefined && result.Levels.length > 0">
                        <li v-for="level in result.Levels" class="ml-3">
                            {{ level.Description }} <tti-toggle></tti-toggle>
                        </li>
                    </ul>
                </li>
            </ul>
        </div> -->

        <div ref="subjects" class="mt-6 space-y-4">
            <!-- <table>
                <tr>
                    <td></td>
                </tr>
                <tr v-for="subject in subjects" :key="subject">
                    <td class="align-top pr-3">{{ subject.name }}</td>
                    <td class="pb-1">
                        <span v-for="level in subject.levels" :key="level" class="block">{{ level }}</span>
                    </td>
                </tr>
            </table> -->

            <!-- <div class="flex align-center space-x-2">
                <tti-toggle :value="showAllLevels" @onChange="showAllLevels = $event" id="showalllevels"></tti-toggle>
                <label for="showalllevels" class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                    Show all available levels for selected subjects
                </label>
            </div> -->

            <div class="divide-y divide-gray-200">
                <div v-for="subject in subjects" :key="subject.name" class="py-4">
                            
                    <!-- <button type="button" class="pt-0.5 flex-shrink-0 flex items-start">
                        <heroicon icon="trash" class="w-5 h-5 text-gray-400 hover:text-gray-500"></heroicon>
                    </button> -->

                    <div class="w-full">
                        <div class="flex justify-between">
                            <h4 class="font-semibold text-lg text-blue-600">{{ subject.name }}</h4>
                            <button type="button" @click="toggleIsEditing(subject)">
                                <heroicon icon="pencil-alt" class="w-6 h-6"></heroicon>
                            </button>
                        </div>
                        <div class="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                            <div v-for="levelSet in subject.levelSets.filter(x => { return subject.isEditing || showAllLevels || x.Levels.some(y => { return y.checked }) })">
                                <div class="flex justify-between sm:justify-start items-baseline space-x-3">
                                    <h5 class="font-medium text-gray-800">{{ levelSet.Description }}</h5>
                                    <button v-if="subject.isEditing" type="button" @click="() => { var foo = !levelSet.Levels.every(y => y.checked); levelSet.Levels.forEach(x => x.checked = foo); }" class="text-xs text-gray-600">{{ levelSet.Levels.every(y => y.checked) ? 'Deselect All' : 'Select All' }}</button>
                                </div>
                                <ul class="mt-1 space-y-1">
                                    <li v-for="level in levelSet.Levels" v-if="level.checked || showAllLevels || subject.isEditing" :key="level.Description" class="flex items-center space-x-2" :class="[level.checked ? 'text-gray-800' : 'text-gray-400']">
                                        <template v-if="subject.isEditing">
                                            <tti-toggle v-if="subject.isEditing" :value="level.checked" @onChange="level.checked = $event"></tti-toggle>
                                            <span @click="level.checked = !level.checked">{{ level.Description }}</span>
                                        </template>
                                        <template v-else>
                                            <heroicon :icon="level.checked ? 'check' : 'x'" class="w-5 h-5"></heroicon>
                                            <span>{{ level.Description }}</span>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- <div class="mt-1 flex flex-wrap space-x-2">
                            <span v-for="level in subject.levels" :key="level" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                {{ level }}
                            </span>
                        </div> -->
                    </div>
                    
                </div>
            </div>
        </div>


    </div>
</template>
<script>

import Vue from 'vue';
import 'vue-select/dist/vue-select.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import SearchService from '@/services/SearchServices'
const searchService = new SearchService();

import TutorService from '@/services/TutorServices'
const tutorService = new TutorService();

export default {
    components: {
        'heroicon': () => import('./Heroicon'),
        'tti-toggle': () => import('./TailwindToggle'),
        'tti-button': () => import('./TailwindButton'),
        'v-select': () => import('vue-select'),
        'multiselect': () => import('vue-multiselect')
    },
    data() {
        return {
            initialSearch: null,
            initialSearchResults: [],
            newInitialSearchResults: [],
            selectedInitialSearch: null,
            noDrop: true,
            refineSearch: null,
            refineSearchResults: [],
            refineSearchResultsTotal: null,
            showAllLevels: false,
            subjects: [],
            suggestionBoxOpen: false,
            suggestionSubject: null,
            suggestionLevels: null,
            suggestionName: null,
            suggestionEmail: null,
            submittingSuggestion: false,
            suggestionSubmitted: false
        }
    },
    computed: {
        selectedSubjectLevels() {
            return this.subjects.map(x => {
                return {
                    subjectId: x.id,
                    levelIds: x.levelSets.map(y => y.Levels.filter(z => z.checked).map(z => z.Id)).flat()
                }
            })
        }
    },
    watch: {
        initialSearch(newVal) { 
            this.onInitialSearch(newVal);
            this.refineSearchResults = [];
        },
        refineSearch(newVal) {
            this.onRefineSearch(newVal, this.selectedInitialSearch.Id);
        },
        // subjects: {
        //     deep: true,
        //     handler() { this.onLevelToggled() }
        // }
    },
    methods: {
        async onInitialSearch(value) {
            
            if (value === '') {
                this.initialSearchResults = [];
                return;
            }

            var results = await searchService.initialSearch(value.trim());

            // var subjects = this.subjects.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));
            // var levels = this.subjects.filter(x => x.levels.some(y => y.toLowerCase().includes(value.toLowerCase())));

            this.initialSearchResults = results.data;
            this.newInitialSearchResults = results.data.results;

            //this.initialSearch = false;
        },
        async onSelectInitialSearch(subjectLevel) {
            var $this = this;

            $this.selectedInitialSearch = Object.assign({}, subjectLevel);

            // if (subjectLevel.Type === 'SUBJECT') {
            //     await $this.onSelectSubject(subjectLevel);
            //     return;
            // }

            this.initialSearch = null;
            this.initialSearchResults = [];

            this.refineSearch = null;
            $this.refineSearchResults = [];

            await $this.onRefineSearch('', subjectLevel.Id);

            Vue.nextTick(() => {
                $this.$refs.refineSearchSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            });
        },
        async onRefineSearch(value, levelId) {
            var $this = this;
            
            var results = await searchService.getSubjectsByName(value.trim(), levelId);

            $this.refineSearchResults = results.data.results;
            $this.refineSearchResultsTotal = results.data.totalCount;
        },
        async onSelectSubject(subject){
            var levelSets = await searchService.getLevelSets(subject.Id);

            for (let i = 0; i < levelSets.data.length; i++) {
                const levelSet = levelSets.data[i];
                
                for (let j = 0; j < levelSet.Levels.length; j++) {
                    const level = levelSet.Levels[j];
                    
                    level.checked = false;
                }
            }

            this.subjects.splice(0, 0, {
                id: subject.Id,
                name: subject.Description,
                isEditing: true,
                levelSets: levelSets.data,
            });

            Vue.nextTick(() => {
                this.$refs.subjects.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            })
            
        },
        toggleIsEditing(subject) {
            subject.isEditing = !subject.isEditing;
            
            if (!subject.isEditing && subject.levelSets.every(x => x.Levels.every(y => !y.checked))) {
                this.subjects.splice(this.subjects.indexOf(subject), 1);
            }
        },
        async onLevelToggled() {
            var requestData = this.selectedSubjectLevels;

            //console.log(JSON.stringify(requestData));

            await tutorService.updateSubjectsTaught(requestData);

            this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        customFilterBy(option, label, search) {
            var labelMatch = (label || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
            var altMatch = (option.AlternativeNames || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
            return labelMatch || altMatch;
        },
        async submitSuggestion() {
            this.submittingSuggestion = true;

            await tutorService.submitSubjectSuggestion({
                subject: this.suggestionSubject,
                levels: this.suggestionLevels,
                name: this.suggestionName,
                email: this.suggestionEmail
            });

            this.submittingSuggestion = false;
            
            this.suggestionBoxOpen = false;
            this.$store.commit('showModal', { icon: 'check-circle', duration: 5000, title: 'Thank you.', description: 'We will review the suggestion and let you know when it’s been added to our database.' });
            this.resetSuggestionForm();
        },
        resetSuggestionForm() {
            this.suggestionLevels = null;
        }
    },
    mounted() {
        // setTimeout(() => {
        //         this.$watch(
        //         () => {
        //             return this.$refs.initialbox.search
        //         },
        //         (newVal) => {
        //             console.log(newVal);
        //             this.noDrop = newVal.length < 2;
        //         }
        //     );
        // }, 2000);
        
        this.subjects = this.$store.state.user.SubjectsTaught;

        // Setup watch here to ensure the subjects array can be populated
        // from Vuex store before the watch is enabled, otherwise it would run
        // immediately after page load.
        this.$watch('selectedSubjectLevels', this.onLevelToggled, { deep: true });

        this.suggestionName = this.$store.state.user.Name;
        this.suggestionEmail = this.$store.state.user.Email;
    }
}
</script>
<style lang="scss">

    .vue-select
    {
        .vs__dropdown-toggle
        {
            padding: 0;
            border: none;
        }

        .vs__search
        {
            margin: 0;
            font-size: 1rem;
            line-height: 1.5rem;
            padding: 0.5rem 0.75rem;
            border: none;

            &::placeholder
            {
                color: #9ca3af;
            }
        }
    }

</style>